import { makeStyles } from '@material-ui/core/styles'

export const useStyles = makeStyles((theme) => {
  const accentColor = theme.palette.primary.main
  const backgroundColor = theme.palette.background.default
  const borderColor = theme.palette.divider

  return {
    divOperacaoLote: {
      display: 'flex',
      flexDirection: 'column',
      height: '100%',
      backgroundColor: backgroundColor,
      color: theme.palette.text.primary,
      overflowX: 'hidden',
    },
    contentWrapper: {
      flexGrow: 1,
      overflowY: 'auto',
      padding: theme.spacing(1),
    },
    titulo: {
      padding: theme.spacing(2, 3),
      borderBottom: `1px solid ${borderColor}`,
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      gap: theme.spacing(1.5),
      [theme.breakpoints.down('xs')]: {
        justifyContent: 'space-between',
      },
    },
    tituloCesta: {
      fontWeight: 600,
      fontSize: '1.3rem',
    },
    tituloIcone: {
      filter: theme.palette.type === 'dark' ? 'invert(1)' : 'none',
    },
    tituloAcoes: {
      padding: theme.spacing(3, 2, 1.5, 2),
      fontSize: '0.85rem',
      fontWeight: 600,
      color: theme.palette.text.secondary,
      textTransform: 'uppercase',
      letterSpacing: '0.8px',
      textAlign: 'center',
    },
    menuAcoes: {
      padding: theme.spacing(0, 1),
    },
    menuItem: {
      display: 'flex',
      alignItems: 'center',
    },
    iconButton: {
      textAlign: 'left',
      justifyContent: 'flex-start',
      borderRadius: theme.shape.borderRadius,
      flexShrink: 1,
      flexGrow: 1,
      color: theme.palette.text.secondary,
      transition: 'background-color 0.2s ease-out, color 0.2s ease-out',
      '&:hover': {
        backgroundColor: theme.palette.action.hover,
        color: accentColor,
      },
      '&:disabled': {
        color: theme.palette.action.disabled,
      },
    },
    tituloAcao: {
      fontWeight: 500,
      fontSize: '0.75rem',
      justifyContent: 'flex-start',
      color: theme.palette.text.primary,
    },
    disabled: {
      color: theme.palette.text.disabled,
    },
    containerCestinha: {
      padding: theme.spacing(1, 2),
    },
    itemCestinha: {
      position: 'relative',
      marginBottom: theme.spacing(2),
      padding: theme.spacing(2),
    },
    tituloItemCestinha: {
      display: 'flex',
      alignItems: 'center',
      gap: theme.spacing(1.5),
      cursor: 'pointer',
      fontWeight: 600,
    },
    informacoesItemCestinha: {
      paddingTop: theme.spacing(1.5),
      marginTop: theme.spacing(1.5),
      borderTop: `1px solid ${theme.palette.divider}`,
      color: theme.palette.text.secondary,
      fontSize: '0.9rem',
    },
    divExcluirItem: {
      position: 'absolute',
      top: theme.spacing(0.5),
      right: theme.spacing(0.5),
    },
    divBotoes: {
      padding: theme.spacing(2),
      borderTop: `1px solid ${borderColor}`,
      backgroundColor: theme.palette.background.paper,
      display: 'flex',
      flexDirection: 'row',
      gap: theme.spacing(1.5),
    },
    carregando: {
      display: 'flex',
      justifyContent: 'center',
      padding: theme.spacing(4),
    },
    gridTituloAcoes: {},
  }
})
